import useIntervalUpdate from 'App/hooks/useIntervalUpdate'
import moment from 'moment'
import getTime from './getTime'

export default function Time(props) {
  useIntervalUpdate(1000)
  return getTime(moment(props.shift.location.date).toDate())
}
